import { createPodletContext } from "@mobility-item-page/client";
import type { PodletsNames } from "src/utils/podlets.ts";

const { PodletsProvider, usePodlets } = createPodletContext<PodletsNames>();

export { PodletsProvider, usePodlets };
